import React from 'react'

// Ported from the source project's src/components/site/Logos.tsx. The source wraps each
// pill in a per-item Reveal (index-staggered entrance). This repo's Reveal (components/reveal)
// only takes a `delay` prop, not `index`/`className`, and the task brief's own index.jsx wires
// Reveal around whole sections (Services, Process) rather than per-item - Logos isn't wrapped
// there either, so this renders plainly with no internal reveal.
const Logos = ({ partners }) => {
    if (!partners.length) return null;
    return (
        <div className="logos-section">
            <div className="logos-label">Technology &amp; Material Partners</div>
            <div className="logos-row">
                {partners.map((p) => (
                    <span className="logo-pill" key={p.order}>{p.name}</span>
                ))}
            </div>
        </div>
    );
};

export default Logos;
